import { constants } from "./general";
import { logAuth, logError, LogCategory } from "./sentryLogger";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_OAUTH_STATE_KEY = "google_oauth_state";
export const GOOGLE_OAUTH_ORIGINAL_PATH = "google_oauth_original_path";

export const initiateGoogleSignIn = async (redirectUri, additionalState = {}) => {
  const currentPath = window.location.pathname + window.location.search;
  const destination = redirectUri || currentPath;
  const isEducator = additionalState.isEducator || false;
  const isSignUp = additionalState.isSignUp || false;
  const hasGroupCode = !!additionalState.groupCode;

  try {
    if (!GOOGLE_CLIENT_ID) {
      const error = new Error("Google Client ID is not configured");
      logError("Google OAuth initiation failed - missing client ID", error, {
        category: LogCategory.AUTH,
        authMethod: constants.GOOGLE,
        originPath: currentPath,
        destination,
      });
      return { success: false, error };
    }

    // Log OAuth initiation
    logAuth("OAuth initiation started", {
      authMethod: constants.GOOGLE,
      originPath: currentPath,
      destination,
      isEducator,
      isSignUp,
      hasGroupCode,
    });

    localStorage.setItem(GOOGLE_OAUTH_ORIGINAL_PATH, currentPath);
    const state = JSON.stringify({
      nonce: Math.random().toString(36).substring(2),
      destination,
      ...additionalState
    });
    localStorage.setItem(GOOGLE_OAUTH_STATE_KEY, state);

    const oauthUrl = new URL("https://accounts.google.com/o/oauth2/v2/auth");
    oauthUrl.searchParams.append("client_id", GOOGLE_CLIENT_ID);
    oauthUrl.searchParams.append("redirect_uri", `${window.location.origin}/auth/callback`);
    oauthUrl.searchParams.append("response_type", "code");
    oauthUrl.searchParams.append("scope", "openid email profile");
    oauthUrl.searchParams.append("state", state);
    oauthUrl.searchParams.append("prompt", "select_account");

    // Redirect to Google's OAuth page
    window.location.href = oauthUrl.toString();
    return { success: true };
  } catch (e) {
    logError("Google OAuth initiation failed", e, {
      category: LogCategory.AUTH,
      authMethod: constants.GOOGLE,
      originPath: currentPath,
      destination,
    });
    return { success: false, error: e };
  }
};
